import axios from 'axios'
import { useToken } from '../hooks/storage/user'
import router from './../router/index'
import { useRoute, useRouter } from 'vue-router'

axios.defaults.baseURL = (window as any).VUE_APP_BASE_URL

// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    if (useToken().get()) config.headers.Authorization = useToken().get()
    return config
  },
  function (error) {
    // 对请求错误做些什么
    router.push('/500')
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    if (response.data.code == 401) useToken().clear()
    if (response.data.code == 403) useToken().clear()

    if (response.data.code != 200) {
      router.push('/500')
    }
    return response
  },
  function (error) {
    // 对响应错误做点什么
    router.push('/500')
    return Promise.reject(error)
  }
)

export default axios
